import moment from 'moment'
import {t} from 'i18next'
import { Card, CardBody, Table } from 'reactstrap'

import { displayDate, isNull } from '../../../izUtils'

const ImportReport = ({report, outdated}) => {
    const isDryRun = report.mode === 'dry_run';
    const records = isNull(report.records) ? {} : report.records;
    const changes = isNull(report.changes) ? {} : report.changes;

    return (
        <Card className="contract-import-report" id={'contract-import-report-' + report.mode}>
            <CardBody>
                <h5>{isDryRun ? t('contracts.import.report.dryRun') : t('contracts.import.report.execute')}</h5>
                <p className="mb-2">{displayDate(moment.utc(report.time), 'datetime')}</p>
                {isDryRun && <p>{t('contracts.import.report.dryRunNote')}</p>}
                {outdated && <p className="text-danger"><b>{t('contracts.import.report.outdated')}</b></p>}

                {report.state !== 'success' ? (
                    <p className="text-danger"><b>{t('contracts.import.report.failed')}: </b>{report.message}</p>
                ) : (
                    <>
                        <h6>{t('contracts.import.report.changes')}</h6>
                        <Table bordered size="sm" style={{ maxWidth: '500px' }}>
                            <tbody>
                                {Object.keys(changes).map(key => (
                                    <tr key={'report-change-' + key}>
                                        <td>{t('contracts.import.rowResult.' + key, {defaultValue: key})}</td>
                                        <td className="text-end">{changes[key]}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <h6>{t('contracts.import.report.records')}</h6>
                        <Table bordered size="sm" style={{ maxWidth: '500px' }}>
                            <thead>
                                <tr>
                                    <th>{t('contracts.import.record')}</th>
                                    <th className="text-end">{t('contracts.import.report.created')}</th>
                                    <th className="text-end">{t('contracts.import.report.updated')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(records).map(key => (
                                    <tr key={'report-record-' + key}>
                                        <td>{t('contracts.import.entities.' + key, {defaultValue: key})}</td>
                                        <td className="text-end">{records[key].created || 0}</td>
                                        <td className="text-end">{records[key].updated || 0}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <p className="mb-1">{t('contracts.import.report.notifications')}: <b>{report.notifications_cleared}</b></p>

                        {!isNull(report.skipped_changes) && report.skipped_changes.length !== 0 &&
                            <p className="text-danger mb-0">{t('contracts.import.report.skipped', {count: report.skipped_changes.length})}</p>
                        }
                    </>
                )}
            </CardBody>
        </Card>
    )
}

export default ImportReport
